import script from "./channel-distribution-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./channel-distribution-chart.vue?vue&type=script&lang=ts&setup=true"

import "./channel-distribution-chart.vue?vue&type=style&index=0&id=2245f62e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2245f62e"]])

export default __exports__